/**
 * Discount entity class
 */

import moment from 'moment'

/**
 * DiscountFactory
 * returns Discount entity class
 *
 * @class DiscountFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Discount} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DiscountFactory
 */
/* @ngInject */
export default function DiscountFactory (Entity, m2mMixin, onOffMixin) {
  /* === Discount class === */

  /**
   * Discount model
   *
   * @class Discount
   * @classdesc Discount model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing Discount entity fields
   * @return {models.Discount} Discount entity
   */
  function Discount () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Discount.prototype = Object.create(Entity.prototype)
  Discount.prototype.constructor = Discount

  /* === Discount instance methods & fields === */

  Object.assign(Discount.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Discount#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      currencyId: Number,
      networkId: Number,
      value: 1,
      maxRedeemAmount: Number,
      type: 'PERCENT',
      createdBy: String,
      startTime: String,
      endTime: String,
      $fromDate: Date,
      $toDate: Date,
      $toDateUnlimited: false,
      $usageUnlimited: false,
      $couponType: 'STANDARD',
      couponCode: String,
      couponOverridesDiscount: true,
      assignedSubscriber: Number,
      usageLimit: 1,
      usageCount: 0
    },

    /**
     * url template
     *
     * @memberof models.Discount#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/discounts/{{::id}}',

    /**
     * Prepare object
     *
     * @memberof models.Discount#
     * @override
     */
    _prepare: function () {
      if (!this.endTime) {
        this.$toDateUnlimited = true
      }

      if (this.usageLimit === -1) {
        this.$usageUnlimited = true
      }

      /* Note: set default values. */
      this.$fromDate = this.startTime ? moment(this.startTime).toDate() : moment().toDate()
      this.$toDate = this.endTime ? moment(this.endTime).toDate() : moment().toDate()
    },

    /**
     * Get underlying object
     *
     * @memberof models.Discount#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      this.startTime = moment.utc(moment(this.$fromDate).tz(moment.defaultZone.name).endOf('day')).format('YYYY-MM-DDTHH:mm:ss[Z]')
      this.endTime = moment.utc(moment(this.$toDate).tz(moment.defaultZone.name).endOf('day')).format('YYYY-MM-DDTHH:mm:ss[Z]')

      if (this.$toDateUnlimited) {
        this.endTime = null
      }

      let ret = Entity.prototype._object.apply(this, arguments)

      return ret
    }

  }, onOffMixin)

  /* === Discount static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Discount, Entity)
  Discount._name = 'Discount'
  Discount._publicName = 'Discount'
  Discount.init()

  // permissions
  Discount.access = {
    view: '',
    create: '',
    edit: '',
    delete: ''
  }

  // extra
  Discount.extra = {
    currencies: []
  }

  return Discount
}
